import Error500 from '@/components/errors/500.vue'
import Error400 from '@/components/errors/400.vue'
import Error404 from '@/components/errors/404.vue'

export default [
  { path: '/napaka', component: Error500, meta: { title: 'Napaka', showFooter: true } },
  { path: '/stran-ne-obstaja', component: Error404, meta: { title: 'Stran ne obstaja', showFooter: true } },
  { path: '/nedovoljen-zahtevek', component: Error400, meta: { title: 'Nedovoljen zahtevek', showFooter: true } },
]
